"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var limitCharacters = function (_a) {
    var text = _a.text, _b = _a.length, length = _b === void 0 ? 144 : _b, _c = _a.breakWord, breakWord = _c === void 0 ? true : _c, _d = _a.more, more = _d === void 0 ? '...' : _d;
    // Always return string back
    if (!text)
        return "";
    // Short-circuit
    if ((text === null || text === void 0 ? void 0 : text.length) < length)
        return text;
    // Trim by length only
    var trimmedText = text.slice(0, length - (more === null || more === void 0 ? void 0 : more.length));
    if (breakWord)
        return "" + trimmedText + more;
    // Trim by words
    var words = trimmedText.split(" ");
    if ((words === null || words === void 0 ? void 0 : words.length) > 1) {
        var trimmedWords = words === null || words === void 0 ? void 0 : words.slice(0, (words === null || words === void 0 ? void 0 : words.length) - 1).join(" ");
        return "" + trimmedWords + more;
    }
    // Fallback
    return text;
};
exports.default = limitCharacters;
